import {GameMetrics, League, Player, Team} from "../../reckon-api";
import {Grow, Stack} from "@mui/material";
import MultipleMetricsSelect from "./Shared/MetricsSelect";
import {useEffect} from "react";
import LeaguesSelect, {SingleLeagueSelect} from "./Competitive/LeagueSelect";
import {Dayjs} from "dayjs";
import DatePicker from "./Shared/DateSelect";
import {targets} from "../../Context";
import {MultiplePatchSelect} from "./PatchSelect";
import RoleSelect, {MultipleRoleSelect} from "./RoleSelect";
import { useReferentialContext} from "../../Context";
import {BlindOrCounter, LaneSwap, SideSelect} from "./YesNoSelector";
import {TeamSelect} from "./TeamSelect";
import YearSelect, {PhaseSelect, SplitSelect} from "./PeriodSelect";
import ServerSelect from "./ServerSelect";
import PlayerSelect from "./PlayerSelect";
import TimestampRangeSelect from "./TimestampRangeSelect";
import {MultipleWardTypeSelect} from "./Shared/WardTypes";

export function to_parameters_object(props: {
    metrics?: GameMetrics[];
    leagues?: League[];
    league?: League;
    date__gte?: Dayjs;
    date__lt?: Dayjs;
    patches?: string[];
    roles?: string[];
    role?: string;
    picktype?: boolean;
    team?: Team;
    vs?: Team;
    side?: string;
    year?: number;
    split?: string;
    phases?: string[];
    servers?: string[];
    player?: Player;
    target?: targets;
    scrimAccount?: string;
    laneSwap?:boolean;
}) {
    const to_ret = {} as any;
    to_ret.additional_filters = {};
    if (props.metrics) to_ret.metrics = props.metrics.map((metric) => metric.code).toString();
    if (props.leagues && !props.leagues.map(league => league.id).includes('All Leagues')) {
        to_ret.additional_filters.league__in = props.leagues.map((league) => league.id).toString();
        console.log(to_ret)
    }
    if (props.date__gte) to_ret.additional_filters.date__gte = props.date__gte.toISOString();
    if (props.date__lt) to_ret.additional_filters.date__lt = props.date__lt.toISOString();
    if (props.patches) to_ret.additional_filters.patch__in = props.patches.toString();
    if (props.roles) to_ret.additional_filters.role__in = props.roles.toString();
    if (props.role) to_ret.role = props.role;
    if (props.player && props.target !== targets.soloq) to_ret.player = props.player.id;
    if (props.player && props.target === targets.soloq) to_ret.competitive_player = props.player.id;
    if (props.league) to_ret.league = props.league.id;
    if (props.team) to_ret.team1 = props.team.id;
    if (props.team) to_ret.team = props.team.id;
    if (props.vs) to_ret.team2 = props.vs.id;
    if (props.side) to_ret.side = props.side;
    if (props.year) to_ret.additional_filters.date__year = props.year;
    if (props.picktype !== null && props.picktype !== undefined) to_ret.is_cp = props.picktype ? 1 : 0;
    if (props.split) to_ret.split = props.split;
    if (props.phases) to_ret.additional_filters.phase__in = props.phases.toString();
    if (props.servers) to_ret.additional_filters.server__in = props.servers.toString();
    if (props.scrimAccount) to_ret.player = props.scrimAccount;
    if (props.laneSwap !== null && props.laneSwap !== undefined) to_ret.lane_swap = props.laneSwap;
    return to_ret;
}

export default function FilterSet(props: {
    paramObject: any;
    setParamObject: any;
    target: targets;
    updateContext?: boolean | undefined;
    metrics?: GameMetrics[];
    setMetrics?: any;
    leagues?: League[];
    setLeagues?: any;
    date__gte?: Dayjs;
    setDateGte?: any;
    date__lt?: Dayjs;
    setDateLt?: any;
    patches?: string[];
    setPatches?: any;
    role?: string;
    setRole?: any;
    agent?: string;
    setAgent?: React.Dispatch<React.SetStateAction<string>>;
    league?: League | null;
    setLeague?: any;
    picktype?: boolean | null;
    setPicktype?: any;
    team?: Team | null;
    setTeam?: any;
    vs?: Team | null;
    setVs?: any;
    side?: string | null;
    setSide?: any;
    roles?: string[];
    setRoles?: any;
    year?: number;
    setYear?: any;
    split?: string | null;
    setSplit?: any;
    phases?: string[];
    setPhases?: any;
    player?: Player|null;
    setPlayer?: any;
    servers?: string[];
    setServers?: any;
    ingameInterval?: number[];
    setIngameInterval?: any;
}) {
    useEffect(() => {
        const new_params_object = to_parameters_object({
            metrics: props.metrics ? props.metrics : undefined,
            leagues: props.leagues ? props.leagues : undefined,
            date__gte: props.date__gte ? props.date__gte : undefined,
            date__lt: props.date__lt ? props.date__lt : undefined,
            patches: props.patches ? props.patches : undefined,
            roles: props.roles ? props.roles : undefined,
            role: props.role ? props.role : undefined,
            picktype: props.picktype !== null && props.picktype !== undefined ? props.picktype : undefined,
            team: props.team ? props.team : undefined,
            vs: props.vs ? props.vs : undefined,
            side: props.side ? props.side : undefined,
            league: props.league ? props.league : undefined,
            year: props.year ? props.year : undefined,
            split: props.split ? props.split : undefined,
            phases: props.phases && props.phases.length > 0 ? props.phases : undefined,
            servers: props.servers && props.servers.length > 0 ? props.servers : undefined,
            player: props.player ? props.player : undefined,

            target: props.target
        });
        if (JSON.stringify(new_params_object) !== props.paramObject.watermark) {
            new_params_object.watermark = JSON.stringify(new_params_object);
            props.setParamObject(new_params_object);
        }
    }, [
        props.metrics,
        props.leagues,
        props.date__gte,
        props.date__lt,
        props.patches,
        props.role,
        props.servers,
        props.picktype,
        props.team,
        props.side,
        props.league,
        props.year,
        props.split,
        props.phases,
        props.player,
        props.ingameInterval,
        props.vs,
    ]);
    const ctx = useReferentialContext();
    return (
            <Stack direction={"row"} sx={{ height: "50px", justifyContent: "left", width: "100%" }} spacing={2}>
                {props.player !== undefined ? <PlayerSelect value={props.player} onChange={props.setPlayer} referential={ctx.playersReferential}></PlayerSelect> : <></>}
                {props.league !== undefined ? <SingleLeagueSelect value={props.league} updateValue={props.setLeague} /> : <></>}
                {props.team !== undefined ? <TeamSelect value={props.team} updateValue={props.setTeam} updateContext={props.updateContext} /> : <></>}
                {props.vs !== undefined ? <TeamSelect value={props.vs} updateValue={props.setVs} updateContext={props.updateContext} /> : <></>}
                {props.leagues ? <LeaguesSelect values={props.leagues} updateValue={props.setLeagues} target={props.target} updateContext={props.updateContext} /> : <></>}
                {props.date__gte ? <DatePicker value={props.date__gte} onChange={props.setDateGte} label={"From"} /> : <></>}
                {props.date__lt ? <DatePicker value={props.date__lt} onChange={props.setDateLt} label={"Until"} /> : <></>}
                {props.patches ? <MultiplePatchSelect values={props.patches} updateValue={props.setPatches} updateContext={props.updateContext} /> : <></>}
                {props.roles ? <MultipleRoleSelect values={props.roles} updateValue={props.setRoles} /> : <></>}
                {props.role ? <RoleSelect value={props.role} onChange={props.setRole} /> : <></>}
                {props.metrics ? <MultipleMetricsSelect values={props.metrics} updateValue={props.setMetrics} target={props.target} updateContext={props.updateContext} /> : <></>}
                {props.picktype !== undefined ? <BlindOrCounter value={props.picktype} onChange={props.setPicktype} label={"Blind / Counter"} /> : <></>}
                {props.side !== undefined ? <SideSelect value={props.side} onChange={props.setSide} /> : <></>}
                {props.year !== undefined ? <YearSelect value={props.year} onChange={props.setYear} /> : <></>}
                {props.split !== undefined ? <SplitSelect value={props.split} onChange={props.setSplit} /> : <></>}
                {props.phases !== undefined ? <PhaseSelect value={props.phases} onChange={props.setPhases} /> : <></>}
                {props.servers ? <ServerSelect values={props.servers} updateValue={props.setServers} /> : <></>}
            </Stack>
    );
}
